module.exports = __webpack_public_path__ + "static/img/loading.bd41cd9.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tic/loading.gif
// module id = Dwk+
// module chunks = 0